import { Profile, Workout, Exercise, DailyAccountability } from '../types/database.types';

export const INITIAL_PROFILE: Profile = {
  id: 'a0000000-0000-0000-0000-000000000001',
  full_name: 'Eduardo (Vida)',
  current_weight_kg: 104.70,
  target_weight_kg: 85.00, // Perda de 19.7kg em 60 dias (Meta ajustada para 85kg)
  target_days: 60,
  height_cm: 180,
  age: 25,
  bmr_kcal: 2098.0,
  body_fat_percent: 32.0, // 33.5kg de gordura
  skeletal_muscle_percent: 34.6, // 36.2kg
  total_muscle_mass_kg: 68.20, // 65.1% massa muscular
  body_water_percent: 49.8, // Baixo -> 5L obrigatórios
  visceral_fat_level: 20.5, // Nível obeso a ser triturado com cardio
  is_on_durateston: true,
  daily_water_target_ml: 5000,
  water_dose_ml: 400,
  wake_up_time: '07:00:00',
  sleep_time: '22:30:00',
  workout_cutoff_time: '19:30:00',
  streak_days: 0, // Ofensiva zerada conforme solicitado
};

export const SEED_WORKOUTS: Workout[] = [
  // SEGUNDA-FEIRA: Treino A (Push)
  {
    id: 'w-1',
    user_id: INITIAL_PROFILE.id,
    name: 'Treino A: Peito, Ombros e Tríceps (Empurrar)',
    description: 'Foco em hipertrofia de feixe clavicular (superior de peito), estabilização escapular e densidade de tríceps.',
    day_of_week: 1, // Segunda-feira
    estimated_duration_min: 55,
    cardio_duration_min: 20,
    cardio_instructions: 'Esteira inclinada (10% a 12% de inclinação) a 5.0 km/h. Mantenha frequência cardíaca entre 125 e 135 bpm (Zona 2 lipolítica).',
    exercises: [
      {
        id: 'ex-1',
        workout_id: 'w-1',
        name: 'Supino Inclinado com Halteres',
        target_muscle: 'Peitoral Superior',
        secondary_muscles: ['Deltoide Anterior', 'Tríceps'],
        demo_url: '/exercises/bench-press.jpg',
        instructions: 'Banco a 30º. Desça em 3 segundos abrindo a caixa torácica e suba com explosão convergindo sem bater os halteres.',
        order_index: 1,
        default_sets: 4,
        target_reps_min: 8,
        target_reps_max: 10,
        default_rest_seconds: 90,
        default_weight_kg: 28,
      },
      {
        id: 'ex-2',
        workout_id: 'w-1',
        name: 'Supino Reto com Barra',
        target_muscle: 'Peitoral Médio',
        secondary_muscles: ['Tríceps', 'Deltoide Anterior'],
        demo_url: '/exercises/bench-press.jpg',
        instructions: 'Pés cravados no chão, escápulas aduzidas. A barra toca a base do esterno. Subida firme com força peitoral.',
        order_index: 2,
        default_sets: 4,
        target_reps_min: 6,
        target_reps_max: 8,
        default_rest_seconds: 120,
        default_weight_kg: 60,
      },
      {
        id: 'ex-3',
        workout_id: 'w-1',
        name: 'Crossover na Polia Média',
        target_muscle: 'Peitoral Médio & Miolo',
        secondary_muscles: ['Deltoide Anterior'],
        demo_url: '/exercises/triceps-pushdown.jpg',
        instructions: 'Passo à frente para base firme. Aperte no centro cruzando ligeiramente os punhos no pico de contração.',
        order_index: 3,
        default_sets: 3,
        target_reps_min: 10,
        target_reps_max: 12,
        default_rest_seconds: 60,
        default_weight_kg: 20,
      },
      {
        id: 'ex-4',
        workout_id: 'w-1',
        name: 'Desenvolvimento Militar com Halteres',
        target_muscle: 'Deltoide Anterior & Lateral',
        secondary_muscles: ['Tríceps'],
        demo_url: '/exercises/shoulder-press.png',
        instructions: 'Banco a 85º. Desça os cotovelos alinhados com o queixo e empurre em linha reta sem hiperestender a coluna.',
        order_index: 4,
        default_sets: 4,
        target_reps_min: 8,
        target_reps_max: 10,
        default_rest_seconds: 90,
        default_weight_kg: 22,
      },
      {
        id: 'ex-5',
        workout_id: 'w-1',
        name: 'Elevação Lateral no Cabo',
        target_muscle: 'Deltoide Lateral',
        secondary_muscles: ['Trapézio Superior'],
        demo_url: '/exercises/shoulder-press.png',
        instructions: 'Polia na altura do joelho. Tensão contínua, cotovelo ligeiramente flexionado, elevação até a linha dos ombros.',
        order_index: 5,
        default_sets: 4,
        target_reps_min: 12,
        target_reps_max: 15,
        default_rest_seconds: 60,
        default_weight_kg: 10,
      },
      {
        id: 'ex-6',
        workout_id: 'w-1',
        name: 'Tríceps Corda na Polia Alta',
        target_muscle: 'Tríceps (Cabeça Lateral)',
        secondary_muscles: ['Antebraço'],
        demo_url: '/exercises/triceps-pushdown.jpg',
        instructions: 'Abra as pontas da corda na extensão total e esprema o tríceps por 1s no ponto de contração máxima.',
        order_index: 6,
        default_sets: 4,
        target_reps_min: 10,
        target_reps_max: 12,
        default_rest_seconds: 60,
        default_weight_kg: 25,
      },
    ],
  },

  // TERÇA-FEIRA: Treino B (Pull)
  {
    id: 'w-2',
    user_id: INITIAL_PROFILE.id,
    name: 'Treino B: Dorsais, Trapézio e Bíceps (Puxar)',
    description: 'Foco na expansão das asas dorsais em V, espessura medial e ativação do pico do bíceps.',
    day_of_week: 2, // Terça-feira
    estimated_duration_min: 55,
    cardio_duration_min: 20,
    cardio_instructions: 'Esteira inclinada (10% a 12% de inclinação) a 5.2 km/h. Respiração ritmada nasal e oral.',
    exercises: [
      {
        id: 'ex-7',
        workout_id: 'w-2',
        name: 'Puxada Frontal Aberta na Polia',
        target_muscle: 'Grande Dorsal (Largura)',
        secondary_muscles: ['Bíceps', 'Braquial'],
        demo_url: '/exercises/lat-pulldown.jpg',
        instructions: 'Puxe direcionando os cotovelos para os bolsos da bermuda. Peito estufado e escápulas ativas.',
        order_index: 1,
        default_sets: 4,
        target_reps_min: 8,
        target_reps_max: 10,
        default_rest_seconds: 90,
        default_weight_kg: 55,
      },
      {
        id: 'ex-8',
        workout_id: 'w-2',
        name: 'Remada Curvada com Barra',
        target_muscle: 'Dorsal Médio & Romboides',
        secondary_muscles: ['Eretores da Espinha', 'Bíceps'],
        demo_url: '/exercises/seated-row.jpg',
        instructions: 'Tronco a 45º, abdômen travado. Barra puxada em direção ao umbigo fechando as costas.',
        order_index: 2,
        default_sets: 4,
        target_reps_min: 8,
        target_reps_max: 10,
        default_rest_seconds: 90,
        default_weight_kg: 50,
      },
      {
        id: 'ex-9',
        workout_id: 'w-2',
        name: 'Remada Baixa com Triângulo',
        target_muscle: 'Espessura Dorsal',
        secondary_muscles: ['Bíceps', 'Braquiorradial'],
        demo_url: '/exercises/seated-row.jpg',
        instructions: 'Alongue na fase excêntrica e puxe encostando o triângulo no abdômen com expansão torácica.',
        order_index: 3,
        default_sets: 3,
        target_reps_min: 10,
        target_reps_max: 12,
        default_rest_seconds: 60,
        default_weight_kg: 45,
      },
      {
        id: 'ex-10',
        workout_id: 'w-2',
        name: 'Crucifixo Invertido no Peck Deck',
        target_muscle: 'Deltoide Posterior',
        secondary_muscles: ['Trapézio Médio'],
        demo_url: '/exercises/shoulder-press.png',
        instructions: 'Abra os braços focando exclusivamente na parte traseira do ombro. Sem utilizar momentum.',
        order_index: 4,
        default_sets: 4,
        target_reps_min: 12,
        target_reps_max: 15,
        default_rest_seconds: 60,
        default_weight_kg: 35,
      },
      {
        id: 'ex-11',
        workout_id: 'w-2',
        name: 'Rosca Direta com Barra W',
        target_muscle: 'Bíceps Braquial',
        secondary_muscles: ['Braquiorradial'],
        demo_url: '/exercises/biceps-curl.png',
        instructions: 'Cotovelos travados na lateral das costelas. Subida concêntrica sem balanço do quadril.',
        order_index: 5,
        default_sets: 4,
        target_reps_min: 8,
        target_reps_max: 10,
        default_rest_seconds: 75,
        default_weight_kg: 24,
      },
      {
        id: 'ex-12',
        workout_id: 'w-2',
        name: 'Rosca Martelo com Halteres',
        target_muscle: 'Braquial & Antebraço',
        secondary_muscles: ['Bíceps'],
        demo_url: '/exercises/biceps-curl.png',
        instructions: 'Pegada neutra contínua para aumentar a largura lateral do braço e antebraço.',
        order_index: 6,
        default_sets: 3,
        target_reps_min: 10,
        target_reps_max: 12,
        default_rest_seconds: 60,
        default_weight_kg: 16,
      },
    ],
  },

  // QUARTA-FEIRA: Treino C (Legs Quad-Focus)
  {
    id: 'w-3',
    user_id: INITIAL_PROFILE.id,
    name: 'Treino C: Quadríceps, Panturrilhas e Abdômen',
    description: 'Máximo estímulo hormonal sistêmico e gasto glicolítico profundo. Preservação de força.',
    day_of_week: 3, // Quarta-feira
    estimated_duration_min: 55,
    cardio_duration_min: 15,
    cardio_instructions: 'Bicicleta ergométrica ou caminhada leve a moderada para remoção de lactato nas pernas.',
    exercises: [
      {
        id: 'ex-13',
        workout_id: 'w-3',
        name: 'Leg Press 45º',
        target_muscle: 'Quadríceps & Glúteos',
        secondary_muscles: ['Isquiotibiais'],
        demo_url: '/exercises/leg-press.jpg',
        instructions: 'Pés na largura dos ombros no centro da plataforma. Desça até 90º sem descolar a lombar.',
        order_index: 1,
        default_sets: 4,
        target_reps_min: 10,
        target_reps_max: 12,
        default_rest_seconds: 120,
        default_weight_kg: 160,
      },
      {
        id: 'ex-14',
        workout_id: 'w-3',
        name: 'Cadeira Extensora',
        target_muscle: 'Reto Femoral & Vasto Lateral',
        secondary_muscles: [],
        demo_url: '/exercises/leg-extension.jpg',
        instructions: 'Segure 1 segundo no topo de cada repetição. Descida controlada de 3 segundos.',
        order_index: 2,
        default_sets: 4,
        target_reps_min: 12,
        target_reps_max: 15,
        default_rest_seconds: 60,
        default_weight_kg: 50,
      },
      {
        id: 'ex-15',
        workout_id: 'w-3',
        name: 'Agachamento Hack / Búlgaro',
        target_muscle: 'Quadríceps & Glúteo Maior',
        secondary_muscles: ['Core'],
        demo_url: '/exercises/leg-press.jpg',
        instructions: 'Desça com profundidade mantendo as costas firmes no encosto da máquina.',
        order_index: 3,
        default_sets: 3,
        target_reps_min: 8,
        target_reps_max: 10,
        default_rest_seconds: 90,
        default_weight_kg: 60,
      },
      {
        id: 'ex-16',
        workout_id: 'w-3',
        name: 'Panturrilha em Pé na Máquina',
        target_muscle: 'Gastrocnêmio & Sóleo',
        secondary_muscles: [],
        demo_url: '/exercises/leg-extension.jpg',
        instructions: 'Amplitude máxima. Desça alongando bem o tendão e suba na ponta dos pés com pausa de 1s.',
        order_index: 4,
        default_sets: 4,
        target_reps_min: 15,
        target_reps_max: 20,
        default_rest_seconds: 60,
        default_weight_kg: 70,
      },
      {
        id: 'ex-17',
        workout_id: 'w-3',
        name: 'Abdominal Crunch na Polia Alta',
        target_muscle: 'Reto Abdominal (Superior e Core)',
        secondary_muscles: [],
        demo_url: '/exercises/abs-crunch.jpg',
        instructions: 'De joelhos, enrole a coluna em direção aos joelhos expelindo todo o ar dos pulmões.',
        order_index: 5,
        default_sets: 4,
        target_reps_min: 15,
        target_reps_max: 20,
        default_rest_seconds: 45,
        default_weight_kg: 35,
      },
    ],
  },

  // QUINTA-FEIRA: Treino D (Deltoides 3D & Braços)
  {
    id: 'w-4',
    user_id: INITIAL_PROFILE.id,
    name: 'Treino D: Deltoides 3D, Braços & Core',
    description: 'Densidade muscular nos pontos visuais de destaque: ombros redondos e braços volumosos.',
    day_of_week: 4, // Quinta-feira
    estimated_duration_min: 55,
    cardio_duration_min: 20,
    cardio_instructions: 'Esteira inclinada (10% a 12%) mantendo 5.0 km/h para queima de gordura visceral.',
    exercises: [
      {
        id: 'ex-18',
        workout_id: 'w-4',
        name: 'Desenvolvimento Arnold com Halteres',
        target_muscle: 'Deltoide Anterior & Médio',
        secondary_muscles: ['Tríceps'],
        demo_url: '/exercises/shoulder-press.png',
        instructions: 'Inicie com as palmas voltadas para o peito e rotacione para frente durante a subida.',
        order_index: 1,
        default_sets: 4,
        target_reps_min: 8,
        target_reps_max: 10,
        default_rest_seconds: 90,
        default_weight_kg: 20,
      },
      {
        id: 'ex-19',
        workout_id: 'w-4',
        name: 'Elevação Lateral com Halteres',
        target_muscle: 'Deltoide Lateral (Ombro 3D)',
        secondary_muscles: ['Trapézio'],
        demo_url: '/exercises/shoulder-press.png',
        instructions: 'Tronco ligeiramente inclinado. Eleve os cotovelos na linha dos ombros sem balançar.',
        order_index: 2,
        default_sets: 4,
        target_reps_min: 12,
        target_reps_max: 15,
        default_rest_seconds: 60,
        default_weight_kg: 12,
      },
      {
        id: 'ex-20',
        workout_id: 'w-4',
        name: 'Tríceps Testa com Barra W',
        target_muscle: 'Tríceps (Cabeça Longa)',
        secondary_muscles: ['Antebraço'],
        demo_url: '/exercises/bench-press.jpg',
        instructions: 'Deitado no banco plano, desça a barra até a linha da testa mantendo os cotovelos fechados.',
        order_index: 3,
        default_sets: 4,
        target_reps_min: 8,
        target_reps_max: 10,
        default_rest_seconds: 75,
        default_weight_kg: 26,
      },
      {
        id: 'ex-21',
        workout_id: 'w-4',
        name: 'Rosca Scott na Máquina / Barra W',
        target_muscle: 'Bíceps (Pico de Contração)',
        secondary_muscles: ['Braquial'],
        demo_url: '/exercises/biceps-curl.png',
        instructions: 'Braços bem apoiados no estofado. Sem descolar os cotovelos ao subir.',
        order_index: 4,
        default_sets: 4,
        target_reps_min: 10,
        target_reps_max: 12,
        default_rest_seconds: 60,
        default_weight_kg: 25,
      },
      {
        id: 'ex-22',
        workout_id: 'w-4',
        name: 'Tríceps Francês Unilateral com Halter',
        target_muscle: 'Tríceps (Cabeça Medial/Longa)',
        secondary_muscles: [],
        demo_url: '/exercises/triceps-pushdown.jpg',
        instructions: 'Braço erguido ao lado da cabeça. Desça o halter atrás da nuca e estenda totalmente.',
        order_index: 5,
        default_sets: 3,
        target_reps_min: 10,
        target_reps_max: 12,
        default_rest_seconds: 60,
        default_weight_kg: 12,
      },
    ],
  },

  // SEXTA-FEIRA: Treino E (Posterior & Glúteo / Cadeia Traseira)
  {
    id: 'w-5',
    user_id: INITIAL_PROFILE.id,
    name: 'Treino E: Posterior de Coxa, Glúteos & Lombar',
    description: 'Equilíbrio articular dos joelhos, queima calórica massiva e fortalecimento da cadeia posterior.',
    day_of_week: 5, // Sexta-feira
    estimated_duration_min: 55,
    cardio_duration_min: 25,
    cardio_instructions: 'Cardio de fechamento de semana: Esteira inclinada 12% a 5.0 km/h por 25 minutos cravados.',
    exercises: [
      {
        id: 'ex-23',
        workout_id: 'w-5',
        name: 'Stiff com Halteres / Barra (RDL)',
        target_muscle: 'Isquiotibiais & Glúteo',
        secondary_muscles: ['Lombar', 'Trapézio'],
        demo_url: '/exercises/deadlift.jpg',
        instructions: 'Pés paralelos, joelhos levemente destravados. Empurre o quadril para trás sentindo alongar a coxa.',
        order_index: 1,
        default_sets: 4,
        target_reps_min: 8,
        target_reps_max: 10,
        default_rest_seconds: 90,
        default_weight_kg: 50,
      },
      {
        id: 'ex-24',
        workout_id: 'w-5',
        name: 'Mesa Flexora Deitado',
        target_muscle: 'Bíceps Femoral',
        secondary_muscles: ['Panturrilha'],
        demo_url: '/exercises/leg-curl.jpg',
        instructions: 'Pressione o quadril contra o estofado e flexione com força até encostar na coxa.',
        order_index: 2,
        default_sets: 4,
        target_reps_min: 10,
        target_reps_max: 12,
        default_rest_seconds: 60,
        default_weight_kg: 40,
      },
      {
        id: 'ex-25',
        workout_id: 'w-5',
        name: 'Elevação Pélvica com Barra / Máquina',
        target_muscle: 'Glúteo Maior',
        secondary_muscles: ['Isquiotibiais'],
        demo_url: '/exercises/deadlift.jpg',
        instructions: 'Pés firmes, empurre pelo calcanhar e aperte o glúteo no topo da contração por 2s.',
        order_index: 3,
        default_sets: 3,
        target_reps_min: 10,
        target_reps_max: 12,
        default_rest_seconds: 75,
        default_weight_kg: 70,
      },
      {
        id: 'ex-26',
        workout_id: 'w-5',
        name: 'Cadeira Flexora Unilateral',
        target_muscle: 'Isquiotibiais Isolado',
        secondary_muscles: [],
        demo_url: '/exercises/leg-curl.jpg',
        instructions: 'Correção de assimetrias. Faça com controle sem levantar os quadris do banco.',
        order_index: 4,
        default_sets: 3,
        target_reps_min: 12,
        target_reps_max: 15,
        default_rest_seconds: 60,
        default_weight_kg: 30,
      },
    ],
  },

  // SÁBADO: Treino F (Cardio Metabólico & Queima Lipídica Acelerada)
  {
    id: 'w-6',
    user_id: INITIAL_PROFILE.id,
    name: 'Treino F: Cardio Metabólico & Queima Lipídica',
    description: 'Aceleração do gasto calórico semanal para quebrar a gordura visceral e afinar a cintura.',
    day_of_week: 6, // Sábado
    estimated_duration_min: 50,
    cardio_duration_min: 35,
    cardio_instructions: '35 minutos contínuos na esteira inclinada ou transporte elíptico na Zona 2 (120-135 bpm).',
    exercises: [
      {
        id: 'ex-27',
        workout_id: 'w-6',
        name: 'Abdominal Infra na Barra Fixa',
        target_muscle: 'Abdômen Inferior',
        secondary_muscles: ['Flexores de Quadril'],
        demo_url: '/exercises/leg-raise.png',
        instructions: 'Pendurado na barra, erga as pernas flexionadas enrolando a bacia para cima.',
        order_index: 1,
        default_sets: 4,
        target_reps_min: 12,
        target_reps_max: 15,
        default_rest_seconds: 45,
        default_weight_kg: 0,
      },
      {
        id: 'ex-28',
        workout_id: 'w-6',
        name: 'Prancha Isométrica com Vácuo Estomacal',
        target_muscle: 'Transverso do Abdômen',
        secondary_muscles: ['Core'],
        demo_url: '/exercises/abs-crunch.jpg',
        instructions: 'Puxe o umbigo para dentro em direção à coluna. Segure a respiração e a tensão por 45s.',
        order_index: 2,
        default_sets: 4,
        target_reps_min: 45,
        target_reps_max: 60,
        default_rest_seconds: 45,
        default_weight_kg: 0,
      },
    ],
  },

  // DOMINGO: Descanso Ativo, Mobilidade & Recuperação Sistêmica
  {
    id: 'w-0',
    user_id: INITIAL_PROFILE.id,
    name: 'Domingo: Descanso Ativo & Mobilidade Regenerativa',
    description: 'Recuperação do Sistema Nervoso Central, restauração articular e desintoxicação celular.',
    day_of_week: 0, // Domingo
    estimated_duration_min: 35,
    cardio_duration_min: 30,
    cardio_instructions: '30 minutos de caminhada regenerativa ao ar livre ou esteira plana a 4.5 km/h. Zero impacto nas articulações.',
    exercises: [
      {
        id: 'ex-0-1',
        workout_id: 'w-0',
        name: 'Alongamento Global & Descompressão de Coluna',
        target_muscle: 'Cadeia Posterior & Lombar',
        secondary_muscles: ['Glúteos', 'Isquiotibiais'],
        demo_url: '/exercises/abs-crunch.jpg',
        instructions: 'Postura da criança e flexão anterior de tronco suave. Mantenha respiração diafragmática profunda e lenta.',
        order_index: 1,
        default_sets: 3,
        target_reps_min: 45,
        target_reps_max: 60,
        default_rest_seconds: 30,
        default_weight_kg: 0,
      },
      {
        id: 'ex-0-2',
        workout_id: 'w-0',
        name: 'Mobilidade de Quadril 90/90',
        target_muscle: 'Rotadores de Quadril & Pélvis',
        secondary_muscles: ['Glúteos'],
        demo_url: '/exercises/abs-crunch.jpg',
        instructions: 'Sentado no colchonete, alterne os joelhos em rotação interna e externa para liberar a articulação coxofemoral.',
        order_index: 2,
        default_sets: 3,
        target_reps_min: 10,
        target_reps_max: 12,
        default_rest_seconds: 30,
        default_weight_kg: 0,
      },
      {
        id: 'ex-0-3',
        workout_id: 'w-0',
        name: 'Vácuo Abdominal & Respiração Diafragmática',
        target_muscle: 'Transverso Abdominal (Cintura Fina)',
        secondary_muscles: ['Assoalho Pélvico'],
        demo_url: '/exercises/abs-crunch.jpg',
        instructions: 'Exale todo o ar e puxe o estômago para dentro e para cima por 20 a 30 segundos.',
        order_index: 3,
        default_sets: 4,
        target_reps_min: 20,
        target_reps_max: 30,
        default_rest_seconds: 45,
        default_weight_kg: 0,
      },
    ],
  },
];

export const INITIAL_ACCOUNTABILITY: DailyAccountability = {
  id: 'acc-today',
  user_id: INITIAL_PROFILE.id,
  date: new Date().toISOString().split('T')[0],
  water_ml_consumed: 0,
  water_target_reached: false,
  workout_completed: false,
  streak_count: 0,
  procrastination_alert_sent: false,
};
